<template>
  <div class="contenedor">
    <div v-show="cargando" class="card indicador-carga">
      <div class="card-body card-separador">
        <div class="spinner-border" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
      </div>
    </div>
    <template v-if="!cargando">
      <div
        v-show="cantidad <= 0"
        class="alert alert-primary info-sin-elementos"
        role="alert"
      >
        <p class="principal">No se encontraron comercios</p>
        <p v-if="infoSinResultados" class="extra">{{ infoSinResultados }}</p>
      </div>
      <div v-show="cantidad > 0" id="tarjetas" class="box-cards-moda">
        <div
          class="contenedor-individual-card"
          v-for="com in comercios"
          v-bind:key="com.id"
        >
          <div class="card-descuento">
            <div class="contenedor-img-desc">
              <img :src="CarpetaLogos + com.logo + IndicadorMiniatura" alt="" />
            </div>
            <div class="card-linc-desc">
              <div class="contenedor-info">
                <div class="nombre">
                  {{ com.nombre }}
                </div>
                <button @click="clickVer(com)">
                  Ver
                  <font-awesome-icon
                    class="icono"
                    :icon="Icons.COMERCIO_ABRIR"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- Por alguna razón no funciona si está dentro de template -->
    <div v-show="!cargando" id="contenedor-paginacion">
      <Paginacion
        :cantidad="cantidad"
        :cantidadPorPagina="CantidadPorPagina"
        v-on:pagina-cambiada="paginaCambiada"
      >
      </Paginacion>
    </div>
  </div>
</template>
<script>
import { environment } from "../environments/environment";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mapState } from "vuex";

import { Api } from "../api";
import {
  Carpetas,
  Icons as IconConstants,
  Paginacion as PaginacionConstantes,
} from "../constants";
import Paginacion from "./Paginacion";
import { Util } from "../util";
import { Vistas } from "../routes/cliente.routes";

export default {
  name: "Tarjetas",
  components: {
    FontAwesomeIcon,
    Paginacion,
  },
  props: {
    busqueda: Object,
    // Si está en verdadero, no se realizarán cargas automáticas
    // Ejemplo en el mounted hook o cuando cambia la búsqueda
    cargaManual: Boolean,
    // Información extra mostrada cuando no se encontraron resultados
    infoSinResultados: String,
  },
  data() {
    return {
      /** Cantidad de beneficios en el servidor (usualmente hay más de los que se muestran en el cliente) */
      cantidad: 0,
      /** Usado para mostrar el indicador de carga */
      cargando: true,
      comercios: [],
      idUsuario: null,
      numeroDePagina: 1,
      token: null,
    };
  },
  computed: {
    CantidadPorPagina() {
      return PaginacionConstantes.COMERCIOS_TARJETAS_POR_PAGINA;
    },
    /**Dirección de la carpeta de logos */
    CarpetaLogos() {
      return environment.API_URL + Carpetas.LOGOS;
    },
    EsUsuario() {
      return this.idUsuario != null && this.token != null;
    },
    /**Constantes de iconos */
    Icons() {
      return IconConstants;
    },
    /**Usado en las imágenes para indicar al servidor que se quiere una miniatura */
    IndicadorMiniatura() {
      return "/mini";
    },
    // Computed properties de vuex
    // Datos compartidos en toda la app
    ...mapState({}),
  },
  watch: {
    busqueda() {
      if (!this.cargaManual) this.cargarPaginasYTarjetas();
    },
  },
  methods: {
    // Los métodos con "Evento" adelante son llamados desde afuera, si se cambia su interface, hay que cambiar afuera
    EventoRecargar(busqueda) {
      this.cargarPaginasYTarjetas(busqueda);
    },
    /**Usado para cargar o recargar beneficios cuando cambia un filtro
     * También carga la paginacion
     */
    cargarTarjetas(busqueda = this.busqueda) {
      if (this.numeroDePagina > 0 && this.cantidad > 0) {
        this.cargando = true;

        // Parámetros de paginación
        const desde = (this.numeroDePagina - 1) * this.CantidadPorPagina + 1;
        const hasta = this.numeroDePagina * this.CantidadPorPagina;

        Api.Comercio.getTodos(this.token, desde, hasta, busqueda)
          .then((response) => {
            this.comercios = response.data;
          })
          .finally(() => {
            this.cargando = false;
          });
      } else {
        this.comercios = [];
        this.cargando = false;
      }
    },
    cargarPaginasYTarjetas(busqueda = this.busqueda) {
      this.cargando = true;

      Api.Comercio.countWithFilter(this.token, busqueda).then((respuesta) => {
        this.cantidad = respuesta.data;

        this.numeroDePagina = 1;

        this.cargarTarjetas(busqueda);
      });
    },
    cerrarModalInfo() {
      this.modalInfoVisible = false;
    },
    clickVer(comercio) {
      this.$router.push("/home/" + Vistas.Comercio.UrlRelativa + "/" + comercio.id);
    },
    paginaCambiada(numero) {
      this.numeroDePagina = numero;
      this.cargarTarjetas();
      // Scrollear hacia arriba
      Util.scrollearAId("tarjetas", true);
    },
    // Cuando usuario se suscribe a un beneficio
    // Se recibe {promesa, beneficio}, la promesa es la petición de suscripción
    // Al server, cuando esta se cumpla significa que se suscribió correctamente
    suscribiendoABeneficio(promesaYBeneficio) {
      promesaYBeneficio.promesa.then(() => {
        this.suscriptoABeneficio(promesaYBeneficio.beneficio.id);
      });
    },
    /**Eliminar un beneficio de la lista cuando se suscribe al beneficio */
    suscriptoABeneficio(idBeneficio) {
      const beneficio = this.beneficios.find((b) => b.id == idBeneficio);

      // Solo eliminarlo si existe en la lista
      if (beneficio != null) this.$store.commit("eliminarBeneficio", beneficio);
    },
  },
  mounted() {
    this.idUsuario = localStorage.getItem("iduser");
    this.token = localStorage.getItem("token");

    if (!this.cargaManual) this.cargarPaginasYTarjetas();
  },
};
</script>
<style scoped>
.contenedor-categoria {
  display: flex;
}

.correccion {
  display: none;
}

.contenedor-individual-card {
  padding: 0 5px 0 5px !important;
  width: 150px !important;
  border-radius: 10px 10px 10px 10px !important;
}

.card-descuento {
  position: relative;
  height: 230px;
  border: 0 !important;
  border-radius: 10px 10px 10px 10px !important;
}

.contenedor-img-desc {
  height: 160px;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: gray;
  border-radius: 10px 10px 0 0 !important;
  position: relative;
}

.contenedor-img-desc img {
  border-radius: 10px 10px 0 0;
  width: 100%;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  background-size: cover;
  position: absolute;
}

.card-linc-desc {
  height: 60px;
  width: 140px;
  position: absolute;
  left: 0;
  justify-items: center;
  display: grid;
}

.contenedor-info {
  position: absolute;
  border-radius: 0 0 10px 10px !important;
  z-index: 0;
  background: white;
  width: 140px;
  bottom: 0;
}

.contenedor-info button {
  display: inline-flex;
  flex-direction: column-reverse;
  text-align: center;
  border-radius: 0 0 10px 10px;
  height: 40px;
  z-index: 100;
  width: 140px;
  padding-bottom: 7px;
  align-items: center;
}

.contenedor-info button:hover {
  border-color: rgb(40, 168, 69) !important;
  background: var(--color-estructura-c);
  text-decoration-color: currentcolor;
}

.contenedor-info button .icono {
  position: absolute;
  bottom: 12px;
  right: 20px;
  color: black;
  z-index: 500;
  font-weight: bold;
}

.box-cards-moda {
  display: grid;
  grid-template-columns: repeat(auto-fill, 150px);
  grid-template-rows: 230px;
  align-items: center;
  justify-content: left;
}

.indicador-carga {
  background-color: transparent;
  border: none;
}

.grid-contenedor-moda {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 200px auto;
  padding-top: 20px;
  background: var(--color-moda-h);
}

#contenedor-paginacion {
  min-height: 100px;
}

/* Extra small devices (portrait phones, less than 576px) */
@media screen and (max-width: 575px) {
  .grid-contenedor-moda {
    grid-gap: 10px;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    padding-top: 8px;
    background: var(--color-moda-h);
  }

  .box-cards-moda {
    justify-content: center;
    margin-top: 0px;
  }

  .correccion {
    display: block;
    position: absolute !important;
    z-index: 1000;
    height: 100%;
    width: 3px !important;
    left: 0;
    margin-top: 60px !important;
  }
}
</style>
